<template>
 <div :class="`section-content-background ${useBgColor ?  'bg-secondary' : ''}`">
  <div :class="`section-content-wrapper ${className ? className : ''} ${paddingSm ? 'padding-sm' : ''} ${noPaddingBottom ? 'no-padding-bottom' : ''}`">
    <slot></slot>
  </div>
 </div>
</template>

<script>
export default {
  name: 'SectionContentWrapper',
  props: {
    className: {
      type: String,
      required: false
    },
    paddingSm: {
      type: Boolean,
      required: false,
      default: false
    },
    useBgColor: {
      type: Boolean,
      required: false,
      default: false
    },
    noPaddingBottom: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
